import { Colonia } from "../../entities/catalogos/Colonia";
import { IRecoleccion } from "../../redux/types/recoleccionActionTypes";

export const MAX_DIRECCION_GUIA_LENGTH = 300;

const trimPart = (value: unknown): string =>
    typeof value === "string" ? value.trim() : "";

const resolvePaisId = (rec: IRecoleccion, distribuidor: Record<string, unknown> | undefined): number => {
    const raw = distribuidor?.paisID ?? distribuidor?.paisId ?? rec.paisId ?? 0;
    const n = Number(raw);
    return Number.isFinite(n) ? n : 0;
};

const resolveColonia = (rec: IRecoleccion, distribuidor: Record<string, unknown> | undefined): Colonia | undefined => {
    if (rec.colonia) {
        return rec.colonia;
    }
    const colonium = distribuidor?.colonium ?? distribuidor?.colonia;
    if (!colonium) {
        return undefined;
    }
    try {
        return colonium instanceof Colonia ? colonium : new Colonia(colonium as Colonia);
    } catch {
        return colonium as Colonia;
    }
};

export const buildGuiaDireccionSnapshot = (rec: IRecoleccion | undefined | null): string => {
    if (!rec) {
        return "";
    }

    const distribuidor = rec.distribuidor as Record<string, unknown> | undefined;
    const paisId = resolvePaisId(rec, distribuidor);

    if (paisId === 0) {
        const fallback =
            trimPart(distribuidor?.fullDireccion)
            || trimPart(distribuidor?.direccion)
            || trimPart(rec.direccion);
        return fallback.length > MAX_DIRECCION_GUIA_LENGTH
            ? fallback.substring(0, MAX_DIRECCION_GUIA_LENGTH)
            : fallback;
    }

    const calle = trimPart(distribuidor?.calle);
    const noExterior = trimPart(distribuidor?.noExterior);
    const codigoPostal = trimPart(distribuidor?.codigoPostal) || trimPart(rec.codigoPostal);
    const telefono = trimPart(distribuidor?.telefono);

    const colonia = resolveColonia(rec, distribuidor);
    const pais = trimPart(colonia?.pais?.nombre);
    const estado = trimPart(colonia?.estado?.nombre);
    const ciudad = trimPart(colonia?.ciudad?.nombre);

    const linea1 = [calle, noExterior, codigoPostal].filter(part => part.length > 0).join(" ");
    const linea1ConEspacio = linea1.length > 0 ? `${linea1} ` : "";
    const linea2 = `${pais},${estado}-${ciudad}`;
    const snapshot = `${linea1ConEspacio}\n${linea2}\n${telefono}`;

    return snapshot.length > MAX_DIRECCION_GUIA_LENGTH
        ? snapshot.substring(0, MAX_DIRECCION_GUIA_LENGTH)
        : snapshot;
};
